import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChartDataService } from '@pg-app/partner/dashboard/services/chart.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogOverviewExampleDialog } from '@pg-app/partner/dashboard/components/dialog/dialog-overview.component';
import { Subscription } from 'rxjs';
import { TableDialogService } from '@pg-app/partner/dashboard/services/table-dialog.service';
import { FunnelDialogOverviewExampleDialog } from '@pg-app/partner/dashboard/components/funnel-dialog/funnel-dialog-overview.component';

@Component({
  selector: 'np-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  donutChartData: Array<any>;
  areaChartData: Array<any>;
  lineChartData: Array<any>;
  public subscription: Subscription;
  public subscriptionFunnel: Subscription;
  notVerify = false;

  constructor(
    private chartDataService: ChartDataService,
    private dialog: MatDialog,
    private tableDialogService: TableDialogService,
  ) {
    this.subscription = this.tableDialogService.TableDialogSubject.subscribe(data => {
      this.dialog.closeAll();
      this.tableDialogService.select(data);
      this.openDialog();
    });

    this.subscriptionFunnel = this.tableDialogService.TableOpportunityDialogSubject.subscribe(data => {
      this.dialog.closeAll();
      this.tableDialogService.selectOpportunity(data);
      this.openDialog('funnel');
    });
  }

  ngOnInit() {
    this.getAreaChartData();
    this.getDonutChart();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.subscriptionFunnel) {
      this.subscriptionFunnel.unsubscribe();
    }
  }

  openDialog(type: string = ''): void {
    let dialog = null;
    if (type === 'funnel') {
      dialog = FunnelDialogOverviewExampleDialog;
    } else {
      dialog = DialogOverviewExampleDialog;
    }
    const dialogRef = this.dialog.open(dialog, {
      width: '80vw',
      height: '87vh',
      id: 'overlay-dialog'
    });
  }

  getDonutChart() {
    this.chartDataService.getDonutChart().subscribe(data => {
      this.donutChartData = data;
    });
  }
  
  getAreaChartData() {
    this.chartDataService.getAreaChartData().subscribe(data => {
      this.areaChartData = data;
    });
  }
}
